<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <alertsp :alertdata="alertdata"></alertsp>
        <v-form
          @submit.prevent="submitPassword"
          ref="formpassword"
          v-model="formin.valid"
          lazy-validation>
          <v-text-field
            v-model="login.password"
            :append-icon="formin.password ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.minpass]"
            :type="formin.password ? 'text' : 'password'"
            name="password"
            label="Password lama"
            hint="At least 6 characters"
            counter
            @click:append="formin.password = !formin.password">
          </v-text-field>
          <v-text-field
            v-model="login.newpassword"
            :append-icon="formin.newpassword ? 'visibility' : 'visibility_off'"
            :rules="[rules.required, rules.minpass]"
            :type="formin.newpassword ? 'text' : 'password'"
            name="newpassword"
            label="Password baru"
            hint="At least 6 characters"
            counter
            @click:append="formin.newpassword = !formin.newpassword">
          </v-text-field>
          <div class="text-center" v-if="loading.changepass">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </div>
          <v-btn
            v-if="!loading.changepass"
            large
            block
            :disabled="!formin.valid"
            color="success"
            class="mr-4 mt-5"
            type="submit">
            Simpan
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Changepassword',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      changepass: false,
    },
    api: process.env.VUE_APP_API,
    login: {
      password: '',
      newpassword: '',
    },
    formin: {
      password: false,
      newpassword: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v && v.length >= 6 || 'Min 6 characters',
      nik: (v) => v && v.length >= 16 || 'Min 16 characters',
    },
    word: 'Vue',
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    submitPassword() {
      this.alertdata.show = false;
      if (this.$refs.formpassword.validate()) {
        if (this.tokenscr) {
          this.loading.changepass = true;
          this.axios
            .post(
              this.api + '/api/penduduk/password',
              qs.stringify(
                this.login,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formpassword.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Password berhasil diubah!';
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.changepass = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.changepass = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
